(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["component-faq"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-pdp-nutrition"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {

	//Set the initial state: highlight the first button...
	$('.nutrition-tabs').find('li:eq(0)').addClass('active');

	//and hide all tab content except the first one
	$('.nutrition-tab-content').find('> div:eq(0)').nextAll().hide();

	//actions that apply on click of any of the buttons
	$('.nutrition-tabs li').click( function(event) {

		//turn off the link so it doesn't try to jump down the page
		event.preventDefault();

		//un-highlight the buttons
		$('.nutrition-tabs li').removeClass();

		//hide all the slides
		$('.nutrition-tab-content > div').hide();

		//highlight the current button
		$(this).addClass('active');

		//get the index of the current button...
		var index = $('.nutrition-tabs li').index(this);

		//and use that index to show the corresponding slide
		$('.nutrition-tab-content > div:eq('+index+')').show();

	});

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-product-recommendations"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-video-hero"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function() {

     $(".hero-button").click(function(event) {
        $("#video-wrapper").css({
           "display": "block",
        });

        $(".video-hero-content").css({
           "display": "none",
        });

        $("#video")[0].src += "&autoplay=1";
        event.preventDefault();
     });

   
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-videos"] && !window.DesignMode) return;
  try {
    

    $(document).ready(function () {
        $('.single-video').click(function () {
            $('.single-video').removeClass('video-selected');
            $(this).addClass('video-selected');
        });
      
       $('.single-video').click(function () {
    		var $url = $(this);
       $('#replaceVideo').attr("src", $url.data('url'));
       $("#component-video-player").css({
          "display": "block",
       });

       $(".default-video-content").css({
          "display": "none",
       });
	   
	   
	   
        });


     $(".play-button").click(function(event) {
        $("#component-video-player").css({
           "display": "block",
        });

        $(".default-video-content").css({
           "display": "none",
        });

        $(".default-video")[0].src += "&autoplay=1";
        event.preventDefault();
     });

   
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

})();
